<template>
    <div class="nch--wiki-history">
        <div v-if="viewing">
            <a href="#" class="small d-inline-block mb-2" :style="{ color: color.primary }" @click.prevent="viewing = null"><i class="fas fa-arrow-left mr-1"></i>{{ $t('wiki.history.back') }}</a>
            <div class="small text-muted mb-2">{{ $t('wiki.history.version', { number: viewing.number }) }} · {{ $t('wiki.history.by', { user: viewing.user || '—' }) }} · {{ date(viewing.created_at) }} · {{ viewing.summary }}</div>
            <div class="nch--wiki-html" v-html="viewing.content"></div>
        </div>

        <template v-else>
            <div v-if="loading" class="text-center text-muted py-4"><i class="fas fa-circle-notch fa-spin"></i></div>
            <div v-else-if="!versions.length" class="text-muted small">{{ $t('wiki.history.empty') }}</div>
            <ul v-else class="list-group list-group-flush">
                <li v-for="v in versions" :key="v.id" class="list-group-item px-0 d-flex align-items-start">
                    <div class="flex-grow-1 min-w-0">
                        <div>
                            <strong>{{ $t('wiki.history.version', { number: v.number }) }}</strong>
                            <span v-if="v.current" class="badge badge-pill badge-primary ml-1" :style="{ backgroundColor: color.primary }">{{ $t('wiki.history.current') }}</span>
                            <span class="ml-2 text-success small">+{{ v.chars_added }}</span> <span class="text-danger small">−{{ v.chars_removed }}</span>
                        </div>
                        <div class="small text-muted">{{ v.summary }} · {{ $t('wiki.history.by', { user: v.user || '—' }) }} · {{ date(v.created_at) }}</div>
                    </div>
                    <button type="button" class="btn btn-sm btn-link nch--view-version" @click="view(v)">{{ $t('wiki.history.view') }}</button>
                </li>
            </ul>
            <div class="small text-muted mt-2"><i class="fas fa-info-circle mr-1"></i>{{ $t('wiki.history.teacher_only') }}</div>
        </template>
    </div>
</template>

<script>
import { friendlyDate } from './wikiHelpers';

/**
 * Histórico da página (backlog#343): versões com resumo, autor, data e
 * delta; ver versão.
 */
export default {
    name: 'WikiHistory',

    props: {
        wikiId: { type: Number, required: true },
        pageId: { type: Number, required: true },
    },

    data: () => ({ versions: [], loading: true, viewing: null }),

    computed: { color() { return this.$store.getters.COLOR || {}; } },

    watch: { pageId() { this.load(); } },

    created() { this.load(); },

    methods: {
        date(v) { return friendlyDate(v, this.$t.bind(this)); },

        load() {
            this.loading = true; this.viewing = null;
            window.axios.get(`/api/app/wikis/${this.wikiId}/pages/${this.pageId}/versions`)
                .then(({ data }) => { this.versions = data || []; })
                .catch(() => { this.versions = []; })
                .finally(() => { this.loading = false; });
        },

        view(v) {
            window.axios.get(`/api/app/wikis/${this.wikiId}/pages/${this.pageId}/versions/${v.id}`).then(({ data }) => { this.viewing = data; }).catch(() => {});
        },
    },
};
</script>

<style>
.min-w-0 { min-width: 0; }
</style>
